import Text from './platform/component/value/Text'
import Image from './platform/component/media/Image'
import Inherit from './platform/component/Inherit'
import Div from './platform/component/Div'
import ScrollIntoView from './platform/api/scroll/ScrollIntoView'
import Listen from './platform/api/event/Listen'
import Merge from './f/object/Merge'
import Wait from './f/control/Wait'
import Default from './f/control/Default'

export default {
	'87f99b85-1c24-4e5b-a903-dd27230f4092': Text,
	'059579bb-184f-435b-ace0-64ec95c9f125': Image,
	'b5286262-9f92-40d3-8545-88fb3079a0f9': Inherit,
	'66698a97-15c5-4602-9925-11a1aeb03710': Div,
	'de9665db-a188-4252-99f0-ea50fc343058': ScrollIntoView,
	'367241d8-ad12-11ea-beed-9777f31699a8': Listen,
	'60bdba6d-c670-430f-be72-6f39cf4e8453': Merge,
	'ba38b0af-80c0-49e4-9e39-864396964ccc': Wait,
	'329920ae-7e91-11ea-988e-1b12488c8b89': Default,
}